// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as WorkSpaceComponent from "./WorkSpaceComponent.bs.js";
import * as CrmControlledReleaseHOC from "../data-source/controlled-rollout/component/CrmControlledReleaseHOC.bs.js";

function LazyWorkSpaceComponentWrapper(Props) {
  var initialTab = Props.initialTab;
  return React.createElement(React.Fragment, undefined, React.createElement(CrmControlledReleaseHOC.make, {
                  children: (function (param) {
                      return React.createElement(WorkSpaceComponent.make, {
                                  initialTab: initialTab
                                });
                    })
                }));
}

var make = LazyWorkSpaceComponentWrapper;

var $$default = LazyWorkSpaceComponentWrapper;

export {
  make ,
  $$default ,
  $$default as default,
  
}
/* react Not a pure module */
